import React from 'react';
import Notification from '../../Components/Notification';
import Layout from '../../Components/Common/Layout';
import AppHeader from '../../Components/Common/Layout/AppHeader';
import { StyledDiv } from '../../Theme/CommonStyled';

const NotificationPage = () => {
  return (
    <>
      <AppHeader title={'notification'} goBack />
      <StyledDiv
        id="notification-container"
        height={'calc(100vh - 60px)'}
        bg={'secondaryBackground'}
        overflow={'auto'}>
        <Notification />
      </StyledDiv>
    </>
  );
};

export default NotificationPage;
